import React from "react";
import { useSelector } from "react-redux";
import { selectAuth } from "../../components/auth/auth.selector";
import AcademyLeadsStructure from "../../components/academy-leads/AcademyLeadsStructure";

const AcademyLeads = () => {
  const authData = useSelector(selectAuth);
  const userInfoData = authData?.user || {};

  return <AcademyLeadsStructure userInfoData={userInfoData} />;
};

export default AcademyLeads;
